import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const AtSign = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M19 30H16C8.28 30 2 23.72 2 16C2 8.28 8.28 2 16 2C23.72 2 30 8.28 30 16V21C30 23.757 27.757 26 25 26C22.243 26 20 23.757 20 21V20.468C18.938 21.42 17.535 22 16 22C12.692 22 10 19.308 10 16C10 12.692 12.692 10 16 10C19.308 10 22 12.692 22 16V21C22 22.654 23.346 24 25 24C26.654 24 28 22.654 28 21V16C28 9.383 22.617 4 16 4C9.383 4 4 9.383 4 16C4 22.617 9.383 28 16 28H19C19.552 28 20 28.448 20 29C20 29.552 19.552 30 19 30ZM16 12C13.794 12 12 13.794 12 16C12 18.206 13.794 20 16 20C18.206 20 20 18.206 20 16C20 13.794 18.206 12 16 12Z" />
	</svg>
);

export default AtSign;
